import {
    Favorite, FavoriteBorderTwoTone, Share, Description, HelpOutline, List,
    Notes, Apps, LibraryMusic, VideoLibrary,
    Cancel, InsertEmoticon, AddCircle, SettingsBrightness,
    Fullscreen, Edit, ListAlt, LibraryAdd, DataUsage, FavoriteBorder, AspectRatio, MusicNote, QueueMusic, CheckBoxOutlineBlank, Menu, Search, Refresh
} from '@material-ui/icons'
import { useDispatch, useSelector } from 'react-redux'
import CommentArea from 'components/harmonize/CommentArea'
import { canLikePost } from 'util/transactionUtils'
import { isAnonymousAccess } from 'util/transactionUtils'
import { deleteLike } from 'util/socialServiceUtils'
import { displayError } from 'util/screenUtils'
import { getAccountId } from 'redux/actions/accountActions'
import { ACCESS_TYPES } from 'components/vortex/CreateVortexRoom'
import { setAllowSwipe } from 'redux/actions/displayActions'
import { useHistory } from 'react-router-dom'
import ErrorLine from 'components/ErrorLine'
import { useState } from 'react'
import SwipeCardHeader from 'components/Header/SwipeCardHeader'
import DisplayLyrics from 'components/truemusic/DisplayLyrics'
import { hasLyricsOrScript } from 'util/documentUtils'
import SignInComponent from 'components/SignInComponent'
import { PLAYER_MODES } from 'redux/reducers/harmonizeReducer'
import { setPlayerMode } from 'redux/actions/harmonizeActions'
import SmallProfileImage from 'components/auction/SmallProfileImage'
import { setCategoryMode } from 'redux/actions/fetchActions'
import { CATEGORY_MODES } from 'redux/reducers/harmonizeReducer'
import { isSongPreview } from 'util/postUtils'
import PriceList from './PriceList'
import { setCreditsToPurchase } from 'redux/actions/purchaseActions'
import { setPostSignInPage } from 'redux/actions/harmonizeActions'
import { setPlayListIndex } from 'redux/actions/harmonizeActions'
import { incrementControlColumnOpacity } from 'redux/actions/settingsActions'
import ShareContent from './ShareContent'
import { Snackbar, useMediaQuery } from '@material-ui/core'
import BlurDialog from 'components/utility/BlurDialog'
import { isGooglebot } from 'util/screenUtils'
import { useEffect } from 'react'
import { setLikedPlayListIndex } from 'redux/actions/harmonizeActions'
import { setPlayList } from 'redux/actions/messagesActions'
import NotificationsBadge from './NotificationsBadge'
import { SONG_BLOCK } from 'redux/reducers/harmonizeReducer'

import { ZINDEX_CONTROLS } from './SwipeCard'
import { addArtistStudios } from 'controllers/CoreServiceController'
import { reset } from 'util/playlistUtils'
import { setPreview } from 'redux/actions/playerControlActions'
import { replaceNewLine } from 'util/postUtils'
import parse from 'html-react-parser'
import { getMessages } from 'controllers/SocialServiceController'
import { buildNewPlaylistEntries } from 'util/playlistUtils'
import { displayHomeIcon } from 'util/brandUtils'
import { setMessages } from 'redux/actions/messagesActions'
import { Alert } from '@mui/material'
import DisplayCredits from 'components/transaction/DisplayCredits'
import AspectRatioControl from './AspectRatioControl'
import Reactor, { REACTOR_STYLE } from './Reactor'
import { getAvailableCredits } from 'controllers/CoreServiceController'
import { setCurrentCredits } from 'redux/actions/creditsActions'
import Playlists from './Playlists'
import Collections from './Collections'
import { getVideoSrc } from 'util/playlistUtils'
import { setCurrentArtistCredits, setCurrentPromotionalCredits } from 'redux/actions/creditsActions'
import Explain from 'components/Explain'
import { isVeryNarrow } from 'util/screenUtils'
import { store } from 'index'
import roundBrainRight from 'images/round-brain-right.png'
import { setShowAi } from 'redux/actions/harmonizeActions'
import AIChat from 'vortex/AIChat'
import { setUserPausedMedia } from 'redux/actions/playerControlActions'
import { addMessageLike } from 'util/messageUtils'
import { getAttachmentLabel } from 'util/documentUtils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEthereum } from '@fortawesome/free-brands-svg-icons'

export default function SwipeCardOverlay({ socket, setCollectionPlaylist, enterFullscreen,
    controlRef }) {
    console.log('----- SwipeCardOverlay')
    const veryNarrow = isVeryNarrow(useMediaQuery)
    const { isArtist, signedIn } = useSelector(state => state.account)
    const { likedPlayListIndex,
        playerMode, postSignInPage, showAi } = useSelector(state => state.harmonize)
    const { categoryMode } = useSelector(state => state.fetch)

    const getCurrentRoom = () => {
        const { currentRoom } = store.getState().messages
        return currentRoom
    }
    const getPlayList = () => {
        const { playList } = store.getState().messages
        return playList
    }
    const getPlayListIndex = () => {
        const { playListIndex } = store.getState().harmonize
        return playListIndex
    }
    const getSong = () => {
        if (getPlayList().length) {
            return getPlayList()[getPlayListIndex()]
        } else {
            return { accessType: ACCESS_TYPES.PROTECTED, name: '' }
        }
    }
    const { controlColumnOpacity } = useSelector(state => state.settings)

    const semiTransparent = 'rgba(0, 0, 0, 0.05)'
    const playerStyles = {
        aiChat: {
            zIndex: ZINDEX_CONTROLS,
            position: 'fixed',
            top: 0,
            display: 'flex',
            width: '100vw',
            height: '100vh',
            backgroundColor: 'lightblue'
        },
        cancelIcon: {
            fontSize: '1.5em',
            color: 'black',
            display: 'flex',
            width: '100%',
            textAlign: 'center'
        },
        controlIcon: {
            fontSize: '2em',
            color: 'white',
            marginTop: '1em',
            borderRadius: '10px',
            backgroundColor: semiTransparent,
            cursor: 'pointer'
        },
        addPostIcon: {
            fontSize: '2.5em',
            color: 'gold',
            marginTop: '0.5em',
            borderRadius: '10px',
            backgroundColor: semiTransparent,
            cursor: 'pointer'
        },
        controlIconNotSelected: {
            fontSize: '2em',
            color: 'gray',
            marginTop: '1em',
            borderRadius: '10px',
            backgroundColor: semiTransparent
        },
        commentArea: {
            padding: 0
        },
        /* Don't extend into the bottom area or player controls on
        the left and right get disabled */
        controlColumn: {
            zIndex: ZINDEX_CONTROLS,
            position: 'fixed',
            top: getCurrentRoom() ? '2em' : '1em',
            display: 'flex',
            flexDirection: 'column',
            width: '2.5em',
            height: '80vh',
            overflowY: 'auto',
            overscrollBehavior: 'contain',//Seems to have no effect
            backgroundColor: `rgba(0,0,0,${controlColumnOpacity})`
        },
        helpLine: {
            display: 'flex',
            alignItems: 'center',
            fontSize: veryNarrow ? '0.9em' : 'inherit', borderBottom: '0.5px dashed black'
        },
        profileImage: {
            marginTop: '1.5em', padding: 0, height: '2.5em',
            width: '2.5em'
        },
        /* This must be fixed position so that it is relative to the browser viewport
        and not to the containing div; otherwise only the top video component 
        displays the text area */
        textArea: {
            zIndex: ZINDEX_CONTROLS,
            borderRadius: '2em',
            bottom: '10vh',
            marginLeft: '1vw',
            paddingLeft: '2em',
            paddingRight: '2em',
            height: '50vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'fixed',
            width: '98vw',
            backgroundColor: 'white',
            overflowY: 'auto',
            overscrollBehavior: 'contain'
        },
        textAreaNoScroll: {
            zIndex: ZINDEX_CONTROLS,
            borderRadius: '2em',
            bottom: '10vh',
            marginLeft: '1vw',
            paddingLeft: '2em',
            paddingRight: '2em',
            height: '50vh',
            flexDirection: 'column',
            position: 'fixed',
            width: '98vw',
            display: 'flex',
            backgroundColor: 'white'
        },
        textAreaReactor: {
            zIndex: ZINDEX_CONTROLS,
            bottom: REACTOR_STYLE.bottomY,
            marginLeft: '1vw',
            height: REACTOR_STYLE.bottom,
            flexDirection: 'column',
            position: 'fixed',
            width: '98vw',
            display: 'flex',
            backgroundColor: 'white',
            overflowY: 'auto',
            overscrollBehavior: 'contain'
        },
    }
    const [helpTarget, setHelpTarget] = useState()
    const [explain, setExplain] = useState()
    const [showAddToPlaylist, setShowAddToPlaylist] = useState(false)
    const [editPlaylists, setEditPlaylists] = useState(false)
    const [showPlaylists, setShowPlaylists] = useState(false)
    const [showShare, setShowShare] = useState(false)
    const [copiedUrl, setCopiedUrl] = useState()
    const [signInPrompt, setSignInPrompt] = useState()
    const [menuOpen, setMenuOpen] = useState(false)
    const [songBlock, setSongBlock] = useState(SONG_BLOCK.NONE)
    const [noPlaylistForCategory, setNoPlaylistForCategory] = useState(false)
    const [error, setError] = useState('')
    const user = getAccountId()
    const dispatch = useDispatch()
    const history = useHistory()
    const displayExplain = () => {

        const { userId, username } = getSong()
        const { currentPromotionalCredits } = store.getState().credits
        return (
            <div style={{ height: '60vh', overflowY: 'auto', overscrollBehavior: 'contain' }}
                onClick={() => setExplain(null)}>
                <p style={playerStyles.helpLine}>
                    Swipe up or down to see new songs and video. Swipe right to like the current one.
                    Click this dialog to hide it.</p>
                <p style={playerStyles.helpLine}>Top of screen</p>
                <p style={playerStyles.helpLine}>
                    <Search style={{ fontSize: '2em' }} />&nbsp;Search by text or hashtag
                </p>
                <p style={playerStyles.helpLine}>
                    <Refresh style={{ fontSize: '2em' }} />&nbsp;Refresh the screen, resetting any search
                </p>
                <p style={playerStyles.helpLine}>
                    <Menu style={{ fontSize: '2em' }} />&nbsp;Show the Harmonize menu
                </p>
                <p style={playerStyles.helpLine}>Left panel</p>
                <p style={playerStyles.helpLine}>
                    <img
                        src={roundBrainRight}
                        style={{
                            height: '2.25em',
                        }}
                    />&nbsp;Use the Harmonize AI
                </p>
                <p style={playerStyles.helpLine}>
                    <SmallProfileImage userId={userId} username={username}
                        imageStyle={{ ...playerStyles.profileImage, ...{ marginTop: 0 } }}
                        click={() => history.push(`/UserProfile/${username}`)} />&nbsp;Go to the artist's Studio.
                </p>
                <p style={playerStyles.helpLine}>
                    {currentPromotionalCredits ?
                        <CheckBoxOutlineBlank
                            style={{ fontSize: '2em', color: 'green' }} /> :
                        <DataUsage style={{ fontSize: '2em' }} />}&nbsp;Displays your current streaming credits.
                    "Pr" means you are enjoying free 10 second previews. Click to buy credits.
                </p>

                <p style={playerStyles.helpLine}>
                    <AddCircle style={{ fontSize: '2em' }} />&nbsp;Add a song or video
                </p>
                <p style={playerStyles.helpLine}>
                    <InsertEmoticon style={{ fontSize: '2em' }} />&nbsp;Use the Reactor for second-by-second
                    reactions
                </p>

                <p style={playerStyles.helpLine}>
                    <FavoriteBorder style={{ fontSize: '2em' }} />&nbsp;Add the current song to your Liked playlist
                </p>
                <p style={playerStyles.helpLine}>
                    <LibraryAdd style={{ fontSize: '2em' }} />&nbsp;Add the current song or video to a custom playlist
                </p>
                <p style={playerStyles.helpLine}>Right panel</p>
                <p style={playerStyles.helpLine}>
                    <Share style={{ fontSize: '2em' }} />&nbsp;Share the current song or video
                </p>
                <p style={playerStyles.helpLine}>
                    <Description style={{ fontSize: '2em' }} />&nbsp;Display story (if any)
                </p>
                <p style={playerStyles.helpLine}>
                    <Notes style={{ fontSize: '2em' }} />&nbsp;Display song lyrics (if any)
                </p>
                <p style={playerStyles.helpLine}>
                    <LibraryMusic style={{ fontSize: '2em' }} />&nbsp;Toggle songs on or off (greyed out is off)
                </p>
                <p style={playerStyles.helpLine}>
                    <VideoLibrary style={{ fontSize: '2em' }} />&nbsp;Toggle videos on or off (greyed out is off)
                </p>
                <p style={playerStyles.helpLine}>
                    <AspectRatio style={{ fontSize: '2em' }} />&nbsp;Toggle between center display and cropped display
                </p>
                <p style={playerStyles.helpLine}>
                    <SettingsBrightness style={{ fontSize: '2em' }} />&nbsp;Darken control panels background
                </p>
                <p style={playerStyles.helpLine}>
                    <Fullscreen style={{ fontSize: '2em' }} />&nbsp;Display video in fullscreen
                </p>
                <p style={playerStyles.helpLine}>Bottom player controls</p>
                <p style={playerStyles.helpLine}>
                    <MusicNote style={{ fontSize: '2em' }} />&nbsp;Single play songs and videos
                </p>
                <p style={playerStyles.helpLine}>
                    <QueueMusic style={{ fontSize: '2em' }} />&nbsp;Continuous play songs and videos
                </p>
            </div>
        )
    }
    const explainOverlay = {
        contentFunction: displayExplain
    }

    const isMyStudio = () => {
        const { currentRoomOwner } = store.getState().messages
        return currentRoomOwner && currentRoomOwner.user === user
    }

    const isSignedIn = () => {
        return signedIn
    }
    /**
     * 
     * @param {*} perform 
     * @param {*} allowPublic 
     * @param {*} prompt      Optional prefix to sign in header message
     * @param {*} postSignIn  Page to go to after sign in succeeds
     */
    const checkAccess = (perform, allowPublic, prompt, postSignIn) => {
        const { accessType } = getSong()
        console.log(`checkAccess accessType ${getSong().accessType}`)
        if (isSignedIn() || (allowPublic && accessType === ACCESS_TYPES.PUBLIC)) {
            console.log(`checkAccess PERFORM allowPublic ${allowPublic} accessType ${accessType}`)
            perform()
        } else {
            doSignIn(prompt, postSignIn)
        }
    }

    const signInContent = () => {
        return (
            <p style={{
                textAlign: 'center', fontSize: '1.1em',
                border: '1px solid gold', padding: '0.25em'
            }}>
                {signInPrompt ? `${signInPrompt}, please sign in or create your free account` : 'Please sign in or create your free account'}</p>
        )
    }

    /**
     * 
     * @param {*} postSignIn Post sign in page. If null this field is reset
     */
    const doSignIn = (prompt, postSignIn) => {
        setSignInPrompt(prompt)
        dispatch(setPostSignInPage(postSignIn))
        updateSongBlock(SONG_BLOCK.SIGN_IN)
    }

    /**
     * The problem with setting state in a callback is that it doesn't affect all
     * component mounts. Redux is for that but we don't want that here to avoid
     * other rerenders.
     * @returns 
     */
    const displaySignIn = () => {
        if (!isSignedIn()) {
            console.log('displaySignIn')
            return (
                <SignInComponent
                    closeOnSuccess={postSignInPage === null}
                    success={() => updateSongBlock(SONG_BLOCK.RESET)}
                    content={() => signInContent()} cancel={() => updateSongBlock(SONG_BLOCK.RESET)}
                />
            )
        }
    }
    const message = (likedPlayListIndex = getPlayListIndex()) => {
        if (getPlayList()[likedPlayListIndex]) {
            return getPlayList()[likedPlayListIndex]

        }
        return { numLikes: 0, liked: false }
    }

    const addLikeToMessage = async () => {
        //console.log(`addLikeToMessage likedPlayListIndex ${likedPlayListIndex}`)
        const { accessType } = getSong()
        if (isAnonymousAccess(accessType)) {
            doSignIn('To like this')
        } else {
            try {
                await addMessageLike(user, message(likedPlayListIndex), getPlayList(), dispatch)
                /*
                const { _id: messageId, userId } = message(likedPlayListIndex)
                if (canLikePost(user, userId, isAnonymousAccess(accessType))) {
                    try {
                        const updatedMessage = await addLikeToMessage(messageId)
                        //console.log('like updatedMessage', updatedMessage)
                        const likedIx = getPlayList().findIndex(pl => pl.messageId === messageId)
                        if (likedIx !== -1) {
                            const { numLikes, liked } = updatedMessage
                            const newEntry = { ...getSong(), numLikes, liked }
                            const update = [
                                ...getPlayList().slice(0, likedIx),
                                newEntry,
                                ...getPlayList().slice(likedIx + 1),
                            ]
                            //console.log('...newEntry', newEntry)
                            dispatch(setPlayList(update))
                        }
                    } catch (error) {
                        console.error('error adding like', error)
                        displayError(error, setError)
                    }
                }*/

            } catch (error) {
                displayError(error, setError, 2)
            }
        }
        dispatch(setLikedPlayListIndex(null))
    }


    /**
     * Because of inability to solve the signin-buy-comebackhere chain
     * we now don't allow this to occur unless signed in
     * @returns 
     */
    const displayPricing = () => {
        console.log('displayPricing')
        return (
            <PriceList clickToPurchase={(creditsToPurchase) => {
                console.log(`creditsToPurchase ${creditsToPurchase}`)
                dispatch(setCreditsToPurchase(creditsToPurchase))
                history.push('/BuyCredits')
            }}
            />
        )
    }

    const displayReactor = () => {
        console.log('displayReactor')
        return (
            <div style={playerStyles.textAreaReactor}>
                <Cancel style={playerStyles.cancelIcon} onClick={() => updateSongBlock(SONG_BLOCK.RESET)} />
                <Reactor controlRef={controlRef} />
            </div>
        )
    }
    const deleteLikeFromMessage = () => {
        const { _id: messageId, accessType, userId } = getSong()
        if (canLikePost(user, userId, isAnonymousAccess(accessType))) {
            try {
                deleteLike(messageId, user, socket)
            } catch (error) {
                console.error('error deleting like', error)
                displayError(error, setError, 3)
            }
        }
    }
    const displayLikes = () => {
        const { numLikes, liked } = message()
        //console.log(`displayLikes numLikes ${numLikes} liked ${liked}`, likes)
        return (
            <div style={{ display: 'flex', paddingRight: numLikes > 0 ? '10px' : '0', alignItems: 'center' }}>
                {liked ?
                    <Favorite style={playerStyles.controlIcon}
                        onClick={(evt) => {
                            evt.stopPropagation()
                            checkAccess(() => deleteLikeFromMessage(), false, 'To unlike this')
                        }} />
                    :
                    <FavoriteBorderTwoTone style={playerStyles.controlIcon}
                        onClick={(evt) => {
                            evt.stopPropagation()
                            checkAccess(() => addLikeToMessage(), false, 'To like this')
                        }} />
                }
                <span style={{ fontWeight: 'bold', color: 'white' }}>{numLikes > 0 ? `${numLikes}` : null}</span>
            </div>
        )
    }

    const displayComments = () => {
        const { comments } = getSong()
        if (comments) {
            return (
                <div style={playerStyles.commentArea}>
                    <CommentArea messageSocket={socket} /></div>)
        }
    }
    /**
     * Scrolling the div fires the Swipe handler even with overscrollBehavior and
     * onTouchMove.
     * @returns 
     */
    const displayDescription = () => {
        const { message: description } = message()
        const jsx = parse(replaceNewLine(description))
        return (
            <div style={playerStyles.textArea}>
                <Cancel style={playerStyles.cancelIcon} onClick={() => updateSongBlock(SONG_BLOCK.RESET)} />
                <div style={{
                    whiteSpace: 'pre-wrap', position: 'relative', overflowY: 'scroll',
                    overscrollBehavior: 'contain',
                    height: '100%'
                }}>
                    {jsx}
                </div>
            </div>
        )
    }
    const displayLyrics = () => {
        const song = getSong()
        const { attachments } = song
        if (attachments) {
            return (
                <div style={playerStyles.textArea}>
                    <Cancel style={playerStyles.cancelIcon} onClick={() => updateSongBlock(SONG_BLOCK.RESET)} />
                    <DisplayLyrics song={song} />
                </div>
            )
        }
    }
    const displayInnerSongBlock = () => {
        console.log(`displayInnerSongBlock ${songBlock}`)
        switch (songBlock) {
            default:
            case SONG_BLOCK.NONE:
                return null
            case SONG_BLOCK.COMMENT:
                return displayComments()
            case SONG_BLOCK.SIGN_IN:
                return displaySignIn()
            case SONG_BLOCK.PRICING:
                return displayPricing()
        }

    }
    const updateSongBlock = (songBlockState) => {
        console.log(`updateSongBlock ${songBlockState}`)
        if (songBlockState === SONG_BLOCK.RESET) {
            dispatch(setAllowSwipe(true))
            setSongBlock(SONG_BLOCK.NONE)
        } else {
            dispatch(setAllowSwipe(false))
            setSongBlock(songBlockState)
        }
    }
    const displaySongBlock = () => {
        console.log(`displaySongBLock ${songBlock}`)
        switch (songBlock) {
            case SONG_BLOCK.NONE:
                return null
            case SONG_BLOCK.LYRICS:
                return displayLyrics()
            case SONG_BLOCK.DESCRIPTION:
                return displayDescription()
            case SONG_BLOCK.REACTOR:
                return displayReactor()
            default:
                return (<div style={playerStyles.textArea}>
                    <Cancel style={playerStyles.cancelIcon} onClick={() => updateSongBlock(SONG_BLOCK.RESET)} />
                    {displayInnerSongBlock()}
                </div>)
        }
    }


    const displayAddToPlaylist = () => {
        if (showAddToPlaylist) {
            const { messageId } = getSong()
            return (
                <Collections
                    addOnly
                    messageId={messageId} close={() => setShowAddToPlaylist(false)} />
            )
        }
    }
    const displayEditPlaylists = () => {
        if (editPlaylists) {
            return (
                <Collections close={() => setEditPlaylists(false)} />
            )
        }
    }

    const displayPlayListControl = () => {
        if (getCurrentRoom()) {
            return (
                <ListAlt style={playerStyles.controlIcon}
                    onClick={() => setShowPlaylists(!showPlaylists)}
                />
            )
        }
    }

    const displayPlayLists = () => {
        if (showPlaylists) {
            return <Playlists
                setCollectionPlaylist={setCollectionPlaylist}
                edit={() => {
                    setShowPlaylists(false)
                    setEditPlaylists(true)
                }}
                close={() => setShowPlaylists(false)} />
        }
    }
    const displayTop = () => {
        return (
            <div
                style={{
                    zIndex: ZINDEX_CONTROLS,
                    top: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'absolute',
                    width: '100%',
                    backgroundColor: 'transparent'
                }}

            >

                <SwipeCardHeader menuOpened={setMenuOpen} setCollectionPlaylist={setCollectionPlaylist}
                />

                {!menuOpen ? <ErrorLine error={error} errorStyle={{ backgroundColor: 'white' }} /> : null}
            </div>
        )
    }

    const handleCreate = () => {
        console.log(`handleCreate isSignedIn ${isSignedIn}`)
        if (isSignedIn()) {
            addArtistStudios()
                .then(() => {
                    history.push(`/CreatePost`)
                })
                .catch(error => displayError(error, setError))
        } else {
            updateSongBlock(SONG_BLOCK.SIGN_IN)
        }
    }
    const displayAI = () => {
        return (
            <div
                style={playerStyles.controlIcon}
                onClick={(evt) => {
                    evt.stopPropagation()
                    checkAccess(() =>
                        dispatch(setShowAi(true)),
                        false,
                        'To use the AI')
                }}>
                <img
                    src={roundBrainRight}
                    style={{
                        height: '1.25em',
                    }}
                />
            </div>
        )
    }
    const displayNFT = () => {
        const { tokenId } = getSong()
        if (tokenId) {
            return (
                <div
                    style={{
                        ...playerStyles.controlIcon, ...{
                            textAlign: 'center',
                            marginTop: '0.5em'
                        }
                    }}
                    onClick={(evt) => {
                        evt.stopPropagation()
                        checkAccess(() =>
                            history.push(`/DisplayNFT/${tokenId}`),
                            false,
                            'To display this NFT')
                    }}>
                    <FontAwesomeIcon icon={faEthereum}
                        style={{

                            color: 'white'
                        }} />
                </div>
            )
        }
    }
    const displayLeft = () => {

        const { userId, username } = getSong()
        return (
            <div style={{ ...playerStyles.controlColumn, ...{ left: 0 } }}
            >
                {displayAI()}
                {/*displayNFT()*/}
                {!isMyStudio() ? <SmallProfileImage userId={userId} username={username} imageStyle={playerStyles.profileImage}
                    click={() => history.push(`/UserProfile/${username}`)} /> : null}
                <NotificationsBadge style={playerStyles.controlIcon} />
                <DisplayCredits song={getSong()}
                    click={() => updateSongBlock(process.env.REACT_APP_USE_PROMOTIONAL_CREDITS === 'true' && !isSignedIn()? SONG_BLOCK.SIGN_IN : SONG_BLOCK.PRICING)
                    } />
                {!getCurrentRoom() || isMyStudio() ? <AddCircle style={playerStyles.addPostIcon}
                    onClick={(evt) => {
                        console.log('Click addCircle currentRoom', getCurrentRoom())
                        evt.stopPropagation()
                        if (getCurrentRoom()) {
                            history.push('/CreatePost')
                        } else {
                            checkAccess(() =>
                                handleCreate(),
                                false,
                                'To upload your song or video',
                                '/CreatePost')
                        }
                    }}
                /> : null}
                <InsertEmoticon style={playerStyles.controlIcon}
                    onClick={(evt) => {
                        evt.stopPropagation()
                        checkAccess(() =>
                            updateSongBlock(songBlock === SONG_BLOCK.NONE ? SONG_BLOCK.REACTOR : SONG_BLOCK.RESET),
                            false,
                            'To leave a reaction')
                    }}
                />
                {displayLikes()}
                {displayPlayListControl()}
                <LibraryAdd
                    onClick={(evt) => {
                        evt.stopPropagation()
                        checkAccess(() => {
                            setShowAddToPlaylist(true)
                        }, false, 'To add to a playlist')
                    }}
                    style={playerStyles.controlIcon} />
                <HelpOutline
                    onClick={(evt) => {
                        evt.stopPropagation()
                        setHelpTarget(evt.currentTarget)
                        setExplain(explainOverlay)
                    }}
                    style={playerStyles.controlIcon} />

            </div>
        )


    }
    const displayModeSelector = () => {
        if (isArtist) {
            switch (playerMode) {
                default:
                case PLAYER_MODES.POST:
                    return (
                        <div style={{ display: 'flex' }}>

                            <div title='Switch to swipeable' style={{ cursor: 'pointer' }}>
                                <Apps style={playerStyles.controlIcon}
                                    onClick={(evt) => {
                                        evt.stopPropagation()
                                        dispatch(setPlayerMode(PLAYER_MODES.SWIPE))
                                    }} /></div>
                        </div>
                    )

                case PLAYER_MODES.SWIPE:
                    return (
                        <div style={{ display: 'flex' }}>
                            <div title='Switch to full listings' style={{ cursor: 'pointer' }}>
                                <List style={playerStyles.controlIcon}
                                    onClick={(evt) => {
                                        evt.stopPropagation()
                                        dispatch(setPlayerMode(PLAYER_MODES.POST))
                                    }} /></div>
                        </div>
                    )

            }
        }

    }

    const getCategoryIcons = () => {
        const musicSelected = categoryMode.type === (CATEGORY_MODES.ALL_MEDIA.type)
            || categoryMode.type === (CATEGORY_MODES.MUSIC.type)
        const videoSelected = categoryMode.type === (CATEGORY_MODES.ALL_MEDIA.type)
            || categoryMode.type === (CATEGORY_MODES.VIDEO.type)
        //console.log(`getCateogryIcons categoryMode music ${musicSelected} video ${videoSelected}`, categoryMode)
        return (
            <div>
                <LibraryMusic style={musicSelected ? playerStyles.controlIcon : playerStyles.controlIconNotSelected}
                    onClick={async (evt) => {
                        evt.stopPropagation()
                        if (videoSelected) {
                            const newCategoryMode = musicSelected ? CATEGORY_MODES.VIDEO : CATEGORY_MODES.ALL_MEDIA
                            dispatch(setCategoryMode(newCategoryMode))
                            reset(dispatch)
                        }
                    }} />
                <VideoLibrary style={videoSelected ? playerStyles.controlIcon : playerStyles.controlIconNotSelected}
                    onClick={async (evt) => {
                        evt.stopPropagation()
                        if (musicSelected) {
                            const newCategoryMode = videoSelected ? CATEGORY_MODES.MUSIC : CATEGORY_MODES.ALL_MEDIA
                            dispatch(setCategoryMode(newCategoryMode))
                            if (getCurrentRoom()) {
                                await getStudioMessages(newCategoryMode)
                            } else {
                                reset(dispatch)
                            }
                        }
                    }} />
            </div>
        )

    }
    const displayCategoryModeSelector = () => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                {getCategoryIcons()}
            </div>
        )
    }
    const displayFullscreen = () => {
        if (getVideoSrc(getSong())) {
            return (
                <Fullscreen
                    style={{ ...playerStyles.controlIcon, ...{ visibility: enterFullscreen ? 'visible' : 'hidden' } }}
                    onClick={enterFullscreen} />)
        }
    }

    /**
     * Next and Previous buttons are required because the video player does not have them
     * @returns 
     */
    const displayRight = () => {
        if (!menuOpen) {
            return (
                <div style={{ ...playerStyles.controlColumn, ...{ right: 0 } }}>
                    {isMyStudio() ? <Edit
                        style={playerStyles.controlIcon}
                        onClick={(evt) => {
                            evt.stopPropagation()
                            const { messageId } = getSong()
                            history.push(`/CreatePost/${messageId}`)
                        }}
                    /> : <Share
                        style={playerStyles.controlIcon}
                        onClick={(evt) => {
                            evt.stopPropagation()
                            setShowShare(!showShare)
                        }}
                    />}
                    {isMyStudio() ? displayModeSelector() : null}
                    <Description
                        onClick={(evt) => {
                            evt.stopPropagation()
                            checkAccess(() => {
                                updateSongBlock(songBlock === SONG_BLOCK.NONE ? SONG_BLOCK.DESCRIPTION : SONG_BLOCK.RESET)
                            }, true, 'To read this story')
                        }}
                        style={playerStyles.controlIcon} />
                    {hasLyricsOrScript(getSong()) ? <Notes
                        onClick={(evt) => {
                            evt.stopPropagation()
                            checkAccess(() => {
                                updateSongBlock(songBlock === SONG_BLOCK.NONE ? SONG_BLOCK.LYRICS : SONG_BLOCK.RESET)
                            }, true, `To read ${getAttachmentLabel(getSong())}`)
                        }}
                        style={playerStyles.controlIcon} /> : null}
                    {displayCategoryModeSelector()}
                    <AspectRatioControl />
                    <SettingsBrightness style={playerStyles.controlIcon}
                        onClick={(evt) => {
                            evt.stopPropagation()
                            dispatch(incrementControlColumnOpacity(controlColumnOpacity))
                        }}
                    />
                    {displayFullscreen()}

                </div>
            )
        }
    }
    const displayCopied = () => {
        if (copiedUrl) {
            return (
                <Snackbar
                    open={copiedUrl}
                    autoHideDuration={2000}
                    onClose={() => setCopiedUrl(false)}
                    message='Copied'
                    anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
                >

                </Snackbar>
            )
        }
    }

    const resetCategory = () => {
        setNoPlaylistForCategory(false)
        dispatch(setCategoryMode(CATEGORY_MODES.ALL_MEDIA))
    }
    const displayNoPlaylistForCategory = () => {
        if (noPlaylistForCategory) {
            const { categories } = categoryMode
            const cats = categories.toString()
            return (
                <Snackbar
                    open={noPlaylistForCategory}
                    autoHideDuration={5000}
                    onClose={() => resetCategory()}
                    anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
                >
                    <Alert onClose={() => resetCategory()} severity='warning'>
                        <span>{`There are no ${cats} entries in this Studio`}</span>
                    </Alert>
                </Snackbar>
            )
        }
    }
    const displayShare = () => {
        if (showShare && !isGooglebot(window.navigator.userAgent)) {
            const { name, handle, messageId } = getSong()

            return (
                <div onClick={(evt) => {
                    evt.stopPropagation()
                    setShowShare(false)
                }}>
                    <BlurDialog content={() =>
                        <ShareContent
                            messageId={messageId}
                            handle={handle}
                            name={name}
                            setCopied={setCopiedUrl}
                        />}
                        hideHelp title={`Share ${name}`} closeIcon />
                </div>
            )
        }
    }
    const displayOverlayOrAI = () => {
        if (showAi) {
            if (controlRef && controlRef.current) {
                controlRef.current.pause()
            }
            dispatch(setUserPausedMedia(true)) //So that MediaPlayer does not start playing
            return (
                <div style={playerStyles.aiChat}>
                    {getCurrentRoom() ?
                        <AIChat roomId={getCurrentRoom()._id} />
                        : <AIChat />} </div>
            )

        } else {
            return (
                <div>
                    {displayLeft()}
                    {displayRight()}
                    {displayTop()}
                </div>
            )
        }
    }
    const displayAll = () => {

        return (
            <div >
                {displayOverlayOrAI()}
                {displaySongBlock()}
                {displayShare()}
                {displayNoPlaylistForCategory()}
                {displayCopied()}
                {displayPlayLists()}
                {displayEditPlaylists()}
                {displayAddToPlaylist()}
                {explain && (
                    <Explain
                        style={{ left: 50, top: 20 }}
                        source={explain}
                        target={helpTarget}
                        close={() => setExplain(null)}
                    />
                )}

            </div>
        )


    }

    const getStudioMessages = async (catMode) => {
        try {
            console.log(`getStudioMessages`, getCurrentRoom())
            const { _id } = getCurrentRoom()
            const studioMessages = await getMessages(_id, 0, 50, catMode.categories)
            console.log('got studio messages', studioMessages)
            if (studioMessages.length) {
                dispatch(setMessages(studioMessages))
                const newPlaylist = await buildNewPlaylistEntries(studioMessages)
                dispatch(setPlayList(newPlaylist))
                displayHomeIcon(setPlayListIndex(0))
            } else {
                setNoPlaylistForCategory(true)
            }
        } catch (error) {
            displayError(error, setError)
        }
    }
    useEffect(() => {
        const { accessType } = getSong()
        console.log(`SwipeCardOverlay useEffect signedIn ${signedIn}`)
        if (isSignedIn()) {
            console.log(`SwipeCardOverlay useEffect getAvailableCredits`)
            getAvailableCredits()
                .then(creditsResponse => {
                    const { availableCredits, availableArtistCredits, promotionalCredits } = creditsResponse
                    console.log(`SwipeCardOverlay set availableCredits ${availableCredits}
                    availableArtistCredits ${availableArtistCredits}`)
                    //setAccount({ ...getStorageAccount(), availableCredits, availableArtistCredits })
                    dispatch(setCurrentCredits(availableCredits))
                    dispatch(setCurrentArtistCredits(availableArtistCredits))
                    dispatch(setCurrentPromotionalCredits(promotionalCredits))
                    dispatch(setPreview(isSongPreview(accessType)))
                })
                .catch(error => displayError(error, setError))
        } else {
            console.log(`SwipeCardOverlay set availableCredits to 0`)
            dispatch(setCurrentCredits(0))
            dispatch(setPreview(isSongPreview(accessType)))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useEffect(() => {
        //console.log(`SwipeCardOverlay useEffect likedPlayListIndex ${likedPlayListIndex}`)
        if (likedPlayListIndex !== null) {
            addLikeToMessage()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [likedPlayListIndex])

    return displayAll()
}
